import { render } from "./DropProfilePage.vue?vue&type=template&id=67ba31db&scoped=true"
import script from "./DropProfilePage.vue?vue&type=script&lang=js"
export * from "./DropProfilePage.vue?vue&type=script&lang=js"

import "./DropProfilePage.vue?vue&type=style&index=0&id=67ba31db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ba31db"]])

export default __exports__